var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.isLiveMessagesPaused)?_c('div',{staticClass:"mb-4 p-4 bg-light"},[_vm._v(" Live messages are paused. ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }